module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-800.bbe9451.woff";